/* MADERO V3.1 — Interaktionen: Header-Transparenz, Wort-Reveals, Parallax, Glow, Tabs, Sticky-CTA */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Grain-Overlay
  if (!document.querySelector('.mv3-grain')) {
    var grain = document.createElement('div');
    grain.className = 'mv3-grain';
    grain.setAttribute('aria-hidden', 'true');
    document.body.appendChild(grain);
  }

  // Header: heller Sticky-Header, Schatten beim Scrollen (V4)
  var header = document.querySelector('.mv3-header');
  var hero = document.querySelector('.mv4-hero, .mv3-coursehero, .mv3-hero');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var burger = header.querySelector('.mv3-burger');
    var panel = header.querySelector('.mv3-mobilenav');
    /* Nur einmal pro Button binden. Wird mv3.js mehrfach eingebunden, haengt der
       Handler sonst doppelt und toggle() oeffnet und schliesst im selben Klick —
       das Menue blieb dadurch auf den Kursseiten tot. 21.08.2026 */
    if (burger && panel && !burger.dataset.mv3Bound) {
      burger.dataset.mv3Bound = '1';
      burger.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        header.classList.toggle('menu-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  // Sticky Mobile CTA
  var sticky = document.querySelector('.mv3-stickycta');
  if (sticky) {
    var footEl = document.querySelector('.mv3-footer');
    var updateSticky = function () {
      var past = hero ? window.scrollY > hero.offsetHeight * 0.7 : window.scrollY > 500;
      var nearFoot = footEl ? footEl.getBoundingClientRect().top < window.innerHeight : false;
      sticky.classList.toggle('is-visible', past && !nearFoot);
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  }

  // Tabs
  document.querySelectorAll('.mv3-tabs').forEach(function (root) {
    var btns = root.querySelectorAll('.mv3-tabs__btn');
    var panels = root.querySelectorAll('.mv3-tabs__panel');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var target = root.querySelector('#' + btn.getAttribute('aria-controls'));
        if (target) target.classList.add('is-active');
      });
    });
  });

  if (reduced) {
    document.querySelectorAll('.mv3-rv, .mv3-words').forEach(function (el) { el.classList.add('is-in'); });
    document.querySelectorAll('.mv3-glow, .mv3-hero').forEach(function (el) { el.classList.add('is-lit'); });
    return;
  }

  // Wort-für-Wort-Reveal für grosse Headlines (.mv3-words)
  document.querySelectorAll('.mv3-words').forEach(function (el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'w';
            var wi = document.createElement('span'); wi.className = 'wi'; wi.textContent = part;
            w.appendChild(wi); frag.appendChild(w);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'SPAN') {
          walk(child);
        }
      });
    };
    walk(el);
    var wis = el.querySelectorAll('.wi');
    wis.forEach(function (wi, i) { wi.style.transitionDelay = (i * 55) + 'ms'; });
  });

  // Hero blüht auf
  if (hero) {
    var light = function () { hero.classList.add('is-lit'); };
    if (document.readyState === 'complete') setTimeout(light, 550);
    else window.addEventListener('load', function () { setTimeout(light, 550); });
  }

  // Reveals + Glow + Wort-Reveals im Viewport
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.classList.contains('mv3-glow')) e.target.classList.add('is-lit');
        io.unobserve(e.target);
      });
    }, { threshold: 0.14 });
    document.querySelectorAll('.mv3-rv, .mv3-glow, .mv3-words').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.mv3-rv, .mv3-words').forEach(function (el) { el.classList.add('is-in'); });
    document.querySelectorAll('.mv3-glow').forEach(function (el) { el.classList.add('is-lit'); });
  }

  // Sanfter Parallax für Hero-Video und [data-parallax]-Medien
  var pxTargets = [];
  var heroMedia = document.querySelector('.mv3-hero__media');
  if (heroMedia) pxTargets.push({ el: heroMedia, depth: 0.12, center: false });
  document.querySelectorAll('[data-parallax]').forEach(function (el) {
    pxTargets.push({ el: el, depth: parseFloat(el.dataset.parallax) || 0.06, center: true });
  });
  if (pxTargets.length) {
    var ticking = false;
    var apply = function () {
      ticking = false;
      var vh = window.innerHeight;
      pxTargets.forEach(function (t) {
        var r = t.el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var progress = t.center ? (r.top + r.height / 2 - vh / 2) / vh : r.top / vh;
        t.el.style.transform = 'translateY(' + (progress * t.depth * -100).toFixed(2) + 'px)';
      });
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  }
})();

/* Sanftes Scrollen für [data-scrollto]-CTAs (z. B. «Platz sichern» → Buchungsmodul) */
(function () {
  document.querySelectorAll('[data-scrollto]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var target = document.querySelector(el.getAttribute('data-scrollto'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
